import React, { useState } from "react";
import "../../index.css";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Call, Man2Rounded, Person } from "@mui/icons-material";

const Contact = (event) => {

    
    const [firstname, setFistName] = useState("");
    const [msg, setMsg] = useState("");
    const [lastname, setListName] = useState("");
    const [email1, setEmail1] = useState("");
    const [number, setNumber] = useState("");

 const contct = (event) => {
    event.preventDefault();
    const reqbody = new FormData();
    reqbody.append("first_name", firstname);
    reqbody.append("last_name", lastname);
    reqbody.append("email", email1);
    reqbody.append("mobile_no", number);
    reqbody.append("customer_messages", msg);

    axios
      .post("https://b1.bhaaraterp.com/Api_data/add-contact-us/", reqbody, {
        headers: {
          "Content-Type": "multipart/form-data",
        
        token: "180bb62dadb769dbb92066bc1669425859895292",
        },
      })
      .then((response) => {
        console.log("Blog added successfully:", response.data);
        alert(response.data.message);
        setFistName("");
        setListName("");
        setEmail1("");
        setMsg("");
        setNumber("");
      })
      .catch((error) => {
        console.error("Error adding blog:", error);
      });
  };

  
  return (
    <>
      <Helmet>
        <title className="">Free Job Searching Portal-Contact US</title>
        <meta
          name="description"
          content="Time to stop struggling to find the right skilled Jobs. At thecareerads.com, brings the best-verified Jobs near you without charges, sharply do the candidate verification with the idea of transforming digital into Reality."
        />
        <meta
          name="keywords"
          content=" free Job Searching Portal, free Job consultant app, job portal, free job portal, free job platform, best job portal "
        />
      </Helmet>

      <div className="">
        <div id="abc" className="hm1 max-h-[450px] ">
          <div className="flex flex-col pt-10  justify-center text-center items-center lg:p-32 p-10 text-white">
            <p className="lg:text-6xl text-3xl font-semibold">
              Contact Career Ads
            </p>

            <p className="lg:text-2xl text-white text-base pt-3">
              Whether you're looking for a demo, have a support question or a
              commercial query get in touch.
            </p>

          </div>
        </div>

        <div className="lg:px-20 px-5 lg:flex-row flex flex-col gap-6 -mt-60 lg:-mt-20 lg:pb-40 pb-5">
          <form className="flex flex-col shadow-lg lg:gap-4 gap-2 lg:text-xl text-base text-[#3b368c] lg:w-1/2 w-full bg-[#cdbafc] rounded-xl lg:p-10 p-5" onSubmit={contct} >

            <p>First Name</p>

            <input
              type="text"
              placeholder="Enter Your First Name"
              className="border lg:p-2 p-1 outline-none"
              onChange={(e) => setFistName(e.target.value)}
                    value={firstname}
            />

            <p>Last Name</p>

            <input
            type="text"
              placeholder="Enter Your Last Name"
              className="border lg:p-2 p-1 outline-none"
              onChange={(e) => setListName(e.target.value)}
              value={lastname}
            />

            <p>Your Email</p>

            <input
            type="text"
              placeholder="Enter Your Email"
              className="border lg:p-2 p-1 outline-none"
              onChange={(e) => setEmail1(e.target.value)}
              value={email1}
            />

            <p>Your Phone Number</p>

            <input
              placeholder="Enter Your Phone Number"
              className="border lg:p-2 p-1 outline-none"
              onChange={(e) => setNumber(e.target.value)}
                    value={number}
            />

            <p>Your Message</p>

            <textarea
              placeholder="Enter Your Message"
              rows={4}
              className="border lg:p-2 p-1 outline-none"
              onChange={(e) => setMsg(e.target.value)}
              value={msg}
            />

            <div className="flex gap-2">
              <input type="checkbox" />
              <p className="text-base">
                I agree to receive emails, newsletters and promotional messages
              </p>
            </div>

            <button
              className="text-xl font-semibold 
        text-white p-3 px-5 bg-violet-400 rounded-full"
        type="submit" 
            >
              SUBMIT
            </button>
          </form>

          <div className="flex flex-col justify-center items-center gap-3 lg:w-1/2 w-full text-[#3b368c] lg:px-24 px-4">
            <div>
             <Man2Rounded/>
            </div>
            <p className="lg:text-4xl text-2xl font-semibold">
              Have Questions ?
            </p>
            <p className="text-xl">
              Have questions about payments or price plans? We have answers!
            </p>
            <div className="flex flex-col gap-5 lg:text-2xl text-lg font-semibold pt-8">
              <div className="flex gap-4">
              <Call/>
                <div>
                  <p>Email Us</p>
                  <p>hr@thecareerads.com</p>
                </div>
              </div>
              <div className="flex gap-4">
              <Call/>
                <div>
                  <p>Call Us</p>
                  <p>+91 9919192991</p>
                </div>
              </div>
              <div className="flex gap-4">
              <Call/>
                <div>
                  <p>Visit Us</p>
                  <p>India</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-200 flex flex-col justify-center items-center">
          <Person className="lg:-mt-24 " />
          <p className="text-4xl font-bold text-[#3b368c] py-6">
            We Are Easy To Find
          </p>
          <div className="google-map-code my-5 mb-16">

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14235.46892874207!2d80.9865663!3d26.875959!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999571e8d949e0f%3A0x14ebc3b6ad475bd9!2sThe%20Career%20Ads!5e0!3m2!1sen!2sin!4v1686819860861!5m2!1sen!2sin"
              className="lg:w-[900px] w-[350px] lg:h-[450px] h-[300px]"
              frameborder="0"
              style={{ border: 0, borderRadius: "20px", boxShadow: "20px" }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>

          </div>
        </div>
      </div>
    </>
  );
};


export default Contact;
